import axios from "axios";
import defaultSetting from '@/setting'
// import store from "@/store";
// import { getToken } from "@/utils/auth";

const service = axios.create({
    baseURL: '',
    timeout: 100000,
});

service.interceptors.request.use(
    (config) => {
        config.data = JSON.stringify(config.data);
        config.headers = {
            "Content-Type": "application/json",
        };
        config.headers.ClientId = defaultSetting.ClientId;
        config.headers.platform = defaultSetting.platform;
        config.headers["Accept-Language"] = "zh-cn";
        // if (store.getters.token) {
        //     config.headers.Authorization = getToken();
        // }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    (response) => {
        if (response.data.state === '200' || response.data.state === 200) {
            return response.data;
        } else {
            const error = new Error();
            if (response.data.state === 500) {
                error.message = response.data.message;
                // Message({
                //     message: error.message,
                //     type: "error",
                //     duration: 5 * 1000,
                // });
                return Promise.reject(error);
            } else if (
                response.data.state === "401" ||
                response.data.state === 401
            ) {
                error.message = "登录失效，请重新登录";
                // store.dispatch("user/logout");
                return Promise.reject(error);
            } else if (
                response.data.state === "201" ||
                response.data.state === 201
            ) {
                return response.data;
            } else {
                if (response.data.msg) {
                    error.message = response.data.msg;
                } else {
                    error.message = response.status + "服务器内部异常";
                }
                // Message({
                //     message: error.message,
                //     type: "error",
                //     duration: 5 * 1000,
                // });
                return Promise.reject(error);
            }
        }
    },
    (error) => {
        if (!error.response || error.response === undefined) {
            error.message = "请检查网络设置";
            return Promise.reject(error);
        }
        switch (error.response.status) {
            case 101:
                break;
            case 401:
                error.message = "登录已过期,请重新登录!";
                // store.dispatch("user/logout");
                break;
            case 403:
                error.message = "禁止访问!";
                break;
            case 503:
                error.message = "服务器升级中!";
                break;
            case 500:
                error.message = "服务内部异常!";
                break;
            default:
                error.message = "未知错误";
        }
        return Promise.reject(error);
    }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, {
        params: params,
      }).then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
  return new Promise((resolve, reject) => {
    service.post(url, data).then(
      (response) => {
        //关闭进度条
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.patch(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.put(url, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}